import React from "react";
import PropTypes from "prop-types";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import PMKBInternal from "./PMKB/PMKBInternal";

const { arrayOf, shape, number, string, node } = PropTypes;

const PMKBGene = (props) => {
  const { data } = props;
  return <PMKBInternal result={data} isGene={true} />;
};

PMKBGene.propTypes = {
  data: shape({
    version: string,
    items: arrayOf(
      shape({
        tier: number,
        definition: arrayOf(string),
        interpretations: string,
        tissues: arrayOf(string),
        tumour_types: arrayOf(string),
        disease_or_trait: node,
        pub_med_references: arrayOf(number),
        variants: arrayOf(
          shape({
            variants: arrayOf(string),
            type: string,
            definition: string,
            gene_id: number,
          })
        ),
      })
    ),
  }),
};

PMKBGene.defaultProps = {
  data: null,
};

export default withErrorGuard(PMKBGene, "PMKBGene", "PMKB");
